import { render, staticRenderFns } from "./GLottie.vue?vue&type=template&id=43fd09a6&scoped=true&"
import script from "./GLottie.vue?vue&type=script&lang=ts&"
export * from "./GLottie.vue?vue&type=script&lang=ts&"
import style0 from "./GLottie.vue?vue&type=style&index=0&id=43fd09a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43fd09a6",
  null
  
)

export default component.exports